export default __webpack_public_path__ + "static/media/IMG_9647.5064d43d.jpg";